<a [routerLink]="redirectPath"
   [disabled]="!basket.isSalable && (redirectPath === '/checkout')"
   cy-checkoutProceed
   [buttonStyle]
   class="w-12">
    {{'Checkout securely'|translate}}
</a>

@if (!basket.isSalable) {
<p class="p2 col-2 m-t-2 center">{{basket.getBasketError() | translate}}</p>
}